import { H5, P } from '../../../AbstractElements';
import React from 'react';
import { Card, CardBody } from 'reactstrap';

const IncomeCard = ({
    iconClass,
    amount,
    title,
    percent,
    trend = 'positive',
    primaryLabel,
    secondaryLabel,
    secondaryAmount,
    trendDirection,
    href = '#javascript',
}) => {
    const hasDailyComparison = Boolean(primaryLabel || secondaryLabel);
    const trendIsNegative = trend === 'negative';
    const trendIsNeutral = trend === 'neutral';
    const resolvedTrendDirection = trendDirection || (
        trendIsNegative
            ? 'down'
            : trendIsNeutral
                ? 'neutral'
                : 'up'
    );
    const trendIcon = resolvedTrendDirection === 'down'
        ? 'fa-arrow-down'
        : resolvedTrendDirection === 'neutral'
            ? 'fa-minus'
            : 'fa-arrow-up';
    const trendClass = trendIsNegative
        ? 'income-trend-negative'
        : trendIsNeutral
            ? 'income-trend-neutral'
            : '';
    const renderKpiValue = value => `${value} ${title}`;

    return (
        <Card className="income-card card-primary">
            <CardBody className="text-center">
                <div className="round-box">
                    {iconClass}
                </div>
                {hasDailyComparison ? (
                    <div className="income-kpi-stack">
                        <div className="income-kpi-row income-kpi-primary">
                            <span>{primaryLabel}</span>
                            <H5>{renderKpiValue(amount)}</H5>
                        </div>
                        <div className="income-kpi-row income-kpi-secondary">
                            <span>{secondaryLabel}</span>
                            <strong>{renderKpiValue(secondaryAmount)}</strong>
                        </div>
                    </div>
                ) : (
                    <>
                        <H5>{amount}</H5>
                        <P>{title}</P>
                    </>
                )}
                <a className={`btn-arrow arrow-primary ${trendClass}`} href={href}>
                    <i className={`toprightarrow-primary fa ${trendIcon} me-2`}></i>{percent} </a>
            </CardBody>
        </Card>
    );
};

export default IncomeCard;
